import { __assign, __extends } from "tslib";
import ReactDOM from 'react-dom';
import React from 'react';
import { Composites, ColorPickerInput, OpacityPicker, TextLabel, InfoIcon, } from '@wix/wix-base-ui';
import { openColorPicker } from '../ColorPicker/openColorPicker';
import { debounce, withoutOpacity } from '../../utils';
var BaseOpacityColorPicker = /** @class */ (function (_super) {
    __extends(BaseOpacityColorPicker, _super);
    function BaseOpacityColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleColorPickerRef = function (ref) {
            _this.colorPickerRef = ref;
        };
        _this.handleInnerOpacityChange = function (opacity) {
            var value = opacity / 100;
            _this.setState({
                opacity: value,
            });
            // This is a workaround for cases, when Opacity color picker calls `handleInnerOpacityChange` when value prop changed.
            // https://github.com/wix-private/wix-base-ui/issues/744
            if (value !== _this.props.value.opacity) {
                _this.handleOpacityChange(value);
            }
        };
        _this.handleOpacityChange = debounce(function (opacity) {
            _this.props.onChange(__assign(__assign({}, _this.props.value), { opacity: opacity }));
        }, 200);
        _this.handleOpenColorPicker = function () {
            var _a = _this.props, SDKAdapter = _a.SDKAdapter, onChange = _a.onChange, onSiteColorsChange = _a.onSiteColorsChange, value = _a.value;
            var position = _this.getPositionOfPicker();
            openColorPicker(SDKAdapter, {
                value: value,
                onChange: onChange,
                onSiteColorsChange: onSiteColorsChange,
                position: position,
            });
        };
        _this.state = {
            opacity: props.value.opacity,
        };
        return _this;
    }
    BaseOpacityColorPicker.prototype.componentDidUpdate = function (props) {
        if (props.value.opacity !== this.props.value.opacity) {
            this.handleOpacityChange.cancel();
            this.setState({
                opacity: this.props.value.opacity,
            });
        }
    };
    BaseOpacityColorPicker.prototype.getPositionOfPicker = function () {
        var dom = ReactDOM.findDOMNode(this.colorPickerRef);
        return dom.getBoundingClientRect();
    };
    BaseOpacityColorPicker.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, label = _a.label, value = _a.value, disabled = _a.disabled, disabledColorPicker = _a.disabledColorPicker, disabledOpacityPicker = _a.disabledOpacityPicker, tooltip = _a.tooltip;
        return (React.createElement("div", { "data-aid": dataHook, "data-hook": dataHook },
            React.createElement(Composites.ColorPickerInputLabeled, null,
                React.createElement(TextLabel, { value: label, automationId: "label", disabled: disabled || (disabledColorPicker && disabledOpacityPicker) }),
                tooltip ? React.createElement(InfoIcon, { text: tooltip }) : null,
                React.createElement(Composites.ColorPickerInput, { automationId: "color" },
                    React.createElement(OpacityPicker, { placeholder: this.props.placeholder || '', value: Math.round(this.state.opacity * 100), onChange: this.handleInnerOpacityChange, opacityGradientColor: withoutOpacity(value.value), automationId: "opacity-picker", min: this.props.min, max: this.props.max, disabled: disabled || disabledOpacityPicker }),
                    React.createElement(ColorPickerInput, { value: withoutOpacity(value.value), ref: this.handleColorPickerRef, onClick: this.handleOpenColorPicker, disabled: disabled || disabledColorPicker })))));
    };
    return BaseOpacityColorPicker;
}(React.Component));
export { BaseOpacityColorPicker };
//# sourceMappingURL=BaseOpacityColorPicker.js.map